const erp = erp || {}

const API_V1 =  process.env.VUE_APP_API_V1; //https://www.eforall.cn/tts/api
const API_V2 =  process.env.VUE_APP_API_V2; //https://api.eforall.cn


erp.h5_hash = process.env.VUE_APP_H5_HASH
erp.h5 = process.env.VUE_APP_H5
erp.apiBase = API_V1
// 获取微信配置
erp.getWxConfig = API_V1 + '/wx/getWxConfig'
//获取微信公众号配置
erp.getWxMPConfig = API_V1 + '/wx/getWxMPConfig'
// 获取通讯录列表
erp.getAddressBookList = API_V1 + '/addressBook/getAddressBookList'

// 获取通讯录详情
erp.getAddressBookDetail = API_V1 + '/addressBook/getAddressBookDetail'

// 更新通讯录信息
erp.upAddressBook = API_V1 + '/addressBook/upAddressBook'

// 获取流水账单
erp.getRechargeList = API_V1 + '/addressBook/getRechargeList'

// 充值缴费
erp.rechargePay = API_V1 + '/addressBook/recharge'

// 寄存展品列表
erp.getAProductList = API_V1 + '/addressBook/getProductList'

// 寄存展品详情
erp.getAProductDetail = API_V1 + '/addressBook/getProductDetail'

// 新建寄存
erp.AddDeposit = API_V1 + '/addressBook/saveDeposit'

// 获取寄存列表
erp.getDepositList = API_V1 + '/addressBook/getDepositList'

// 获取寄存列表详情
erp.getDepositDetail = API_V1 + '/addressBook/getDepositDetail'

// 获取通知列表
erp.getNoticeList = API_V1 + '/addressBook/getNoticeList'

// 展品寄存申请
erp.depositApply = API_V1 + '/addressBook/saveProductDeposit'

// 取出申请
erp.takeOut = API_V1 + '/addressBook/takeOut'

// 同意寄存/同意取出
erp.agreeApply = API_V1 + '/addressBook/agreeApply'

// 拒绝寄存/拒绝取出
erp.refuseApply = API_V1 + '/addressBook/refuseApply'

// 撤销寄存/撤销取出
erp.revokeApply = API_V1 + '/addressBook/revokeApply'

// 再次申请寄存/再次申请取出
erp.againApply = API_V1 + '/addressBook/againApply'


//知识库
erp.getKnowledgeCateList = API_V1 + '/knowledge/getKnowledgeCateList'
erp.getKnowledgeList = API_V1 + '/knowledge/getKnowledgeList'
erp.getKnowledgeInfo = API_V1 + '/knowledge/getKnowledgeInfo'



// 写入芯片时间
erp.upChipCodeTime = API_V1 + '/product/upChipCodeTime'
// 获取芯片写入时间
erp.getChipCodeTime = API_V1 + '/product/getChipCodeTime'

// 写入芯片
erp.chipWrite = API_V1 + '/product/chipWrite'
// 芯片读取
erp.chipRead = API_V1 + '/product/chipRead'

// 获取活动列表
erp.getActivityList = API_V1 + '/activity/getActivityList'
// 添加活动
erp.addActivity = API_V1 + '/activity/saveActivity'

// 分享活动
erp.shareActivity = API_V1 + '/activity/shareActivity'

// 删除活动
erp.delActivity = API_V1 + '/activity/removeActivity'
// 修改活动
erp.updateActivity = API_V1 + '/activity/updateActivity'
// 关闭活动
erp.closeActivity = API_V1 + '/activity/closeActivity'
// 获取中奖名单
erp.getWinningList = API_V1 + '/activity/getWinlogList'
// 获取抽奖活动信息
erp.getLotteryInfo = API_V1 + '/activity/intoWinlog'
// 发起抽奖
erp.lotteryStart = API_V1 + '/activity/saveWinlog'
// 获取抽奖记录
erp.getLotteryRecord = API_V1 + '/activity/getWinlogList'
// 添加备注
erp.addRemake = API_V1 + '/activity/addRemake'
// 领取奖品
erp.receivePrize = API_V1 + '/activity/addWinlog'
// 查询店铺是否有活动
erp.whetherActivity = API_V1 + '/activity/whetherActivity'
// 删除奖品
erp.removePrize = API_V1 + '/activity/removePrize'

// 订单添加备注
erp.editOrderComment = API_V1 + '/order/editOrderComment'
// 添加展号
erp.saveTProductNum = API_V1 + '/order/saveTProductNum'

// 获取芯片码
erp.getChipCodeList = API_V1 + '/product/getChipList'
// 获取芯片详情
erp.getChipDetail = API_V1 + '/product/getChipDetail'

// 替换芯片码
erp.chipReplace = API_V1 + '/product/chipReplace'

// 获取版本号
erp.getVersion = API_V1 + '/version/getVersion'
// 查询菜单是否需要密码
erp.getStoreItem = API_V1 + '/StorePower/getStoreItem'

// 输入密码显示菜单
erp.checkPassword = API_V1 + '/StorePower/checkPassword'

// 生成商品二维码
erp.createQrCode = API_V1 + '/upload/common/createQrCode'

// 支付宝获取APP支付数据
erp.getAppOrderData = API_V1 + '/aliPay/getAppOrderData'

// 获取背景美化订单数据 支付宝
erp.getApplyBackgroundBeautifyOrderData = API_V1 + '/aliPay/getApplyBackgroundBeautifyOrderData'

// 获取背景美化订单数据 微信
erp.purchaseApplyBackgroundBeautifyOrder = API_V1 + '/wx/purchaseApplyBackgroundBeautifyOrder'
// 统一下单微信
erp.createOrder = API_V1 + '/wx/createOrder'
// 获取验证码
erp.sendCode = API_V1 + '/user/sendCode'
// APP注册
erp.registered = API_V1 + '/user/registered'
//检测手机号是否已被注册
erp.checkPhone = API_V1 + '/user/checkPhone'
//登录
erp.login = API_V1 + '/user/login'

//微信登录
erp.wxLogin = API_V1 + '/user/wx-login'
erp.mpLogin = API_V1 + '/user/mp-login'
// 获取温馨提示    类型【1：注册温馨提示】【2：隐私协议】【3：用户协议】【4：用户手册】
erp.getRegisteredTip = API_V1 + '/user/getRegisteredTip'
// 忘记密码校验手机号码
erp.forgetPasswordCheckPhone = API_V1 + '/user/forgetPasswordCheckPhone'
// 忘记密码重置密码
erp.ResetPasswordByPhone = API_V1 + '/user/ResetPasswordByPhone'

//创建购买展品模板订单
erp.saveTemplateOrder = API_V1 + '/product/saveTemplateOrder'

// 获取我的信息
erp.getUserInfo = API_V1 + '/user/getUserInfo'

// 用户查看个性化账号申请进度
erp.PersonalizationUsernameQueryApplicationsProgress = API_V1 + '/personalizationusername/PersonalizationUsernameQueryApplicationsProgress'

// 用户个性化账号申请添加
erp.PersonalizationUsernameRegister = API_V1 + '/personalizationusername/PersonalizationUsernameRegister'



// 更新用户信息
erp.updateUesrInfo = API_V1 + '/StoreMessage/updateUesr'

// 保存我的信息
erp.saveStoreMessage = API_V1 + '/StoreMessage/saveStoreMessage'

// 修改绑定手机号
erp.updatePhone = API_V1 + '/StoreMessage/updatePhone'

// 注销用户
erp.LogOutUser = API_V1 + '/StoreMessage/LogOutUser'

// 修改密码
erp.updatePassWord = API_V1 + '/StoreMessage/updatePassWord'

// 根据ID获取地址
erp.getAddressById = API_V1 + '/user/getAddressById'

// 获取我的地址列表
erp.getUserAddressList = API_V1 + '/user/getUserAddressList'

// 删除地址
erp.removeUserAddress = API_V1 + '/user/removeUserAddress'

// 添加地址
erp.saveUserAddress = API_V1 + '/user/saveUserAddress'

// 设置默认地址
erp.setAddressStatus = API_V1 + '/user/setAddressStatus'

// 修改地址
erp.updateUserAddress = API_V1 + '/user/updateUserAddress'

// 获取我的公告列表
erp.getAnnouncementList = API_V1 + '/user/getAnnouncementList'

// 删除公告
erp.removeAnnouncement = API_V1 + '/user/removeAnnouncement'

// 添加公告
erp.saveAnnouncement = API_V1 + '/user/saveAnnouncement'

// 修改公告
erp.updateAnnouncement = API_V1 + '/user/updateAnnouncement'

// 获取备忘录详情
erp.getMemoDetail = API_V1 + '/user/getMemoDetail'

// 获取备忘录列表
erp.getMyMemoList = API_V1 + '/user/getMyMemoList'

// 获取备忘录分类导航列表
erp.getNavbarList = API_V1 + '/user/getNavbarList'

// 删除备忘录
erp.removeMemo = API_V1 + '/user/removeMemo'

// 添加备忘录
erp.saveMemo = API_V1 + '/user/saveMemo'

// 修改备忘录
erp.updateMemo = API_V1 + '/user/updateMemo'

// 编辑记事本分类
erp.updateMemoCat = API_V1 + '/user/updateMemoCat'


// 保存扫描芯片用户的具定位
erp.saveUserAddressLocaltionList = API_V1 + '/user/localtion/saveUserLocaltionAddress'
// 保存读取扫描芯片用户的具定位
erp.saveUserAddressReadChipLocaltionList = API_V1 + '/user/readChip/localtion/saveUserReadChipAddress'
// 芯片详情
erp.getUserAddressChipDetail = API_V1 + '/user/readChip/localtion/getUserAddressChipDetail'
// 修改芯片详情备注
erp.updateUserReadChipAddress = API_V1 + '/user/readChip/localtion/updateUserReadChipAddress'



// 图片上传
erp.upload = API_V1 + '/upload/common/upload'

// 图片删除
erp.deleteImg = API_V1 + '/upload/common/delete'
// 视频压缩
erp.videoCompression = API_V1 + '/upload/common/videoCompression'

// 获取平台客服列表
erp.getPlatformContactService = API_V1 + '/user/getPlatformContactService'

// 获取我的客服列表
erp.getStoreContactService = API_V1 + '/user/getStoreContactService'

// 删除我的客服
erp.removeContactService = API_V1 + '/user/removeContactService'

// 添加我的客服
erp.saveContactService = API_V1 + '/user/saveContactService'

// 编辑我的客服
erp.updateContactService = API_V1 + '/user/updateContactService'

// 查询用户是否购买功能权限
erp.getUserWhetherPurchaseStorePermissions = API_V1 + '/StorePower/getUserWhetherPurchaseStorePermissions'
// 查询用户是否有相应权限 新写的
erp.getMyStorePermissions = API_V1 + '/StorePower/getMyStorePermissions'

// 购买店铺权限
erp.purchaseStorePermissions = API_V1 + '/StorePower/purchaseStorePermissions'

// 获取已购买的店铺权限
erp.getPurchaseStorePermissionsList = API_V1 + '/StorePower/getPurchaseStorePermissionsList'

// 获取店铺付费权限
erp.getPayStorePermissionsList = API_V1 + '/StorePower/getPayStorePermissionsList'

// 获取全部店铺权限
erp.getAllStorePermissionsList = API_V1 + '/StorePower/getAllStorePermissionsList'

// 获取当前店铺的权限
erp.getMyStorePermissionsList = API_V1 + '/StorePower/getMyStorePermissionsList'

// 评论已购买的功能权限
erp.commentseStorePermissions = API_V1 + '/StorePower/commentseStorePermissions'

// 获取展台群列表
erp.getStoreGrouplist = API_V1 + '/storeGroup/getStoreGrouplist'

// 查询展台群成员信息
erp.getStoreGroupMember = API_V1 + '/storeGroup/getStoreGroupMember'

// 用户查询邀请记录
erp.getInvitationRecord = API_V1 + '/storeGroup/getInvitationRecord'

// 展台群二维码
erp.GroupQRCode = API_V1 + '/storeGroup/GroupQRCode'

// 邀请店铺进入展台群
erp.invitationStoreGroup = API_V1 + '/storeGroup/invitationStoreGroup'

// 添加展台群
erp.saveStoreGroup = API_V1 + '/storeGroup/saveStoreGroup'

// 用户扫描二维码加入展台群
erp.scanQRCodeAddGroup = API_V1 + '/storeGroup/scanQRCodeAddGroup'

// 用户同意或拒绝邀请
erp.updateInvitation = API_V1 + '/storeGroup/updateInvitation'

// 修改展台群名称
erp.updateStoreGroup = API_V1 + '/storeGroup/updateStoreGroup'

// 邀请展主
erp.getAttentionStore = API_V1 + '/storeGroup/getAttentionStore'

// 获取广告店铺列表
erp.getAdvertisingStoreList = API_V1 + '/product/getAdvertisingStoreList'

// 确认展位
erp.saveProductApply = API_V1 + '/product/saveProductApply'
erp.saveCarousel = API_V1 + '/product/saveCarousel'



// 获取我收到的广告店铺列表
erp.getReceivedList = API_V1 + '/product/getReceivedList'

erp.getCarouselList = API_V1 + '/product/getCarouselList'

// 获取我发布的广告店铺列表
erp.getReleasedList = API_V1 + '/product/getReleasedList'

// 通过广告审核
erp.passApprove = API_V1 + '/product/passApprove'

// 驳回广告审核
erp.refuseApprove = API_V1 + '/product/refuseApprove'

// 获取展厅列表
erp.getProductList = API_V1 + '/product/getProductList'

//获取店铺的展品列表
erp.getStoreProductList = API_V1 + '/product/getStoreProductList'

// 获取展品详情
erp.getProductDetail = API_V1 + '/product/getProductDetail'

// 删除展品
erp.removeProduct = API_V1 + '/product/removeProduct'

// 修改排序号
erp.updateProductSort = API_V1 + '/product/updateProductSort'

// 上架/下架
erp.upShelf = API_V1 + '/product/upShelf'

// 添加保存/修改展品
erp.saveProduct = API_V1 + '/product/saveProduct'


erp.saveCarouselProduct = API_V1 + '/product/saveCarouselProduct'
erp.advertStatus = API_V1 + '/product/advertStatus'
erp.getMyCarouselList = API_V1 + '/product/getMyCarouselList'

// 添加展品类别
erp.saveMyType = API_V1 + '/user/saveMyType'

// 获取分类列表
erp.getMyTypeList = API_V1 + '/user/getMyTypeList'

// 获取记事本分类列表
erp.getMemoTypeList = API_V1 + '/user/getMemoTypeList'

// 添加记事本类别
erp.saveMyMemoCat = API_V1 + '/user/saveMyMemoCat'

// 编辑分类
erp.updateType = API_V1 + '/user/updateType'

// 获取平台分类
erp.getPlatformProductType = API_V1 + '/store/getPlatformProductType'

// 获取我的模板库列表
erp.getStoreTemplateLibraryList = API_V1 + '/product/getStoreTemplateLibraryList'

// 获取我的模板库详情
erp.getStoreTemplateLibraryDetails = API_V1 + '/product/getStoreTemplateLibraryDetails'

// 用户使用平台模板库
erp.usePlatformTemplateLibrary = API_V1 + '/product/usePlatformTemplateLibrary'

// 获取模板详情/套用模板
erp.getTemplateDetail = API_V1 + '/product/getTemplateDetail'

// 新建我的模板库
erp.addStoreTemplateLibrary = API_V1 + '/product/addStoreTemplateLibrary'

// 新建/修改我的模板
erp.saveStoreTemplate = API_V1 + '/product/saveStoreTemplate'

// 模板一二级分类
erp.getTemplateType = API_V1 + '/product/getTemplateType'

// 展台商品添加到模板库
erp.exhibitionHallProductAddTemplateLibrary = API_V1 + '/product/exhibitionHallProductAddTemplateLibrary'

// 使用模板库
erp.useTemplateLibrary = API_V1 + '/product/useTemplateLibrary'

// 获取平台模板库列表
erp.getPlatformTemplatelibraryList = API_V1 + '/product/getPlatformTemplatelibraryList'

// 获取平台模板库详情
erp.getPlatformTemplatelibraryDetails = API_V1 + '/product/getPlatformTemplatelibraryDetails'

// 获取平台模板详情
erp.getPlatformTemplateDetails = API_V1 + '/product/getPlatformTemplateDetails'

// 用户购买平台模板库
erp.buyPlatformTemplateLibrary = API_V1 + '/product/buyPlatformTemplateLibrary'


// 发布美工(商品)
erp.saveStoreArt = API_V1 + '/product/saveStoreArt'

// 获取我发布的（美工）列表(商品)
erp.getStoreArtList = API_V1 + '/product/getStoreArtList'

// 用户申请美背景图美化
erp.addApplyBackgroundBeautify = API_V1 + '/backgroundBeautify/addApplyBackgroundBeautify'

// 用户查询背景图美化申请进度
erp.getApplicationRecord = API_V1 + '/backgroundBeautify/getApplicationRecord'

// 获取选择美工列表 (商品)
erp.getArtList = API_V1 + '/product/getArtList'

// 获取美工订单详情(商品)
erp.getArtOrderDetail = API_V1 + '/product/getArtOrderDetail'

// 获取美工列表 (背景)
erp.getApplyBackgroundBeautifyOrderList = API_V1 + '/backgroundBeautify/getApplyBackgroundBeautifyOrderList'

// 确认美工订单(商品)
erp.confirmArtOrder = API_V1 + '/product/confirmArtOrder'

// 确认美工订单(背景)
erp.updatePaymentState = API_V1 + '/backgroundBeautify/updatePaymentState'

// 获取美工列表
erp.getArtistInfoList = API_V1 + '/backgroundBeautify/getArtistInfoList'

// 获取个人图库
erp.getUserBackground = API_V1 + '/StoreMessage/getUserBackground'

// 移到我的背景图库
erp.MovetoUserBackground = API_V1 + '/StoreMessage/MovetoUserBackground'

// 新增背景图
erp.saveBackGround = API_V1 + '/StoreMessage/saveBackGround'

// 上传背景图
erp.uploadBackground = API_V1 + '/StoreMessage/uploadBackground'

// 获取平台图库类型
erp.getBackgroundType = API_V1 + '/StoreMessage/getBackgroundType'

// 获取平台图库
erp.getSystemBackground = API_V1 + '/StoreMessage/getSystemBackground'

// 获取我发布补货订单列表
erp.getReplenishList = API_V1 + '/product/getReplenishList'

// 补货订单详细信息（我发布的）
erp.getReplenishDetails = API_V1 + '/product/getReplenishDetails'

// 获取我收到补货订单列表
erp.getSellerReplenishList = API_V1 + '/product/getSellerReplenishList'

// 商品补货
erp.getStoreReplenish = API_V1 + '/product/getStoreReplenish'

// 确认补货订单
erp.confirmReplenish = API_V1 + '/product/confirmReplenish'

// 报价页面商品详情
erp.getSellerReplenishDetails = API_V1 + '/product/getSellerReplenishDetails'

// 补货订单卖家报价
erp.SellerReplenishQuotation = API_V1 + '/product/SellerReplenishQuotation'

// 补货卖家确认收款
erp.replenishSellerProceeds = API_V1 + '/product/replenishSellerProceeds'

// 补货卖家发货
erp.replenishSellerShipments = API_V1 + '/product/replenishSellerShipments'

// 商品补货
erp.getStoreReplenish = API_V1 + '/product/getStoreReplenish'

// 获取供货商列表(我关注的店铺)
erp.getSupplierList = API_V1 + '/product/getSupplierList'

// 发布商品补货
erp.saveStoreReplenish = API_V1 + '/product/saveStoreReplenish'

// 店铺权限购买wx
erp.createStorePermissionsOrder = API_V1 + '/wx/createStorePermissionsOrder'

// 店铺权限购买支付宝
erp.getStorePermissionsOrderData = API_V1 + '/aliPay/getStorePermissionsOrderData'

//平台添加到我的模板
erp.savePlateformTemplateToMy = API_V1 + '/product/savePlateformTemplateToMy'

// 获取分类列表
erp.getMyTypeList = API_V1 + '/user/getMyTypeList'

// 添加分类
erp.saveMyType = API_V1 + '/user/saveMyType'

// 编辑分类
erp.updateType = API_V1 + '/user/updateType'


//用户确认收货
erp.replenishBuyerReceiving = API_V1 + '/product/replenishBuyerReceiving'


// 添加展品类别
erp.getStoreList = API_V1 + '/store/getStoreList'
// 获取店铺首页
erp.getHomePageStore = API_V1 + '/store/getHomePageStore'
// 获取店铺详情
erp.getStoreDetail = API_V1 + '/store/getStoreDetail'
// 关注店铺
erp.attentionStore = API_V1 + '/store/attentionStore'
// 获取平台分类
erp.getPlatformProductType = API_V1 + '/store/getPlatformProductType'
// 搜索商品
erp.search = API_V1 + '/store/search'
// 获取商品详情
erp.getProductDetail1 = API_V1 + '/store/getProductDetail'

// 获取商品相关链接
erp.getStoreExtractLink = API_V1 + '/store/get-store-extract-link'

erp.getAdvertProductDetail = API_V1 + '/store/getAdvertProductDetail'

erp.getShelfList = API_V1 + '/shelf/get-shelf-list'
erp.getShelfProducts = API_V1 + '/shelf/get-shelf-products'
erp.addNewShelf = API_V1 + '/shelf/add-new-shelf'
erp.renameShelf = API_V1 + '/shelf/rename-shelf'
erp.removeShelf = API_V1 + '/shelf/remove-shelf'
erp.removeProductFromShelf = API_V1 + '/shelf/remove-product-from-shelf'
erp.saveProductShelves = API_V1 + '/shelf/save-product-shelves'
erp.saveProductListShelves = API_V1 + '/shelf/save-product-list-shelves'
erp.selectProductList =  API_V1 + '/shelf/select-product-list'

// 确认商品所有者权限
erp.checkOwner = API_V1 + '/store/checkOwner'
// 评论点赞/取消点赞
erp.commentLike = API_V1 + '/store/commentLike'
// 获取评论列表
erp.getCommentList = API_V1 + '/store/getCommentList'
//获取我的展台详情
erp.getStoreMessage = API_V1 + '/StoreMessage/getStoreMessage'
// 保存到购物车
erp.saveShopCar = API_V1 + '/order/saveShopCar'
// 获取购物车列表
erp.getShopCarList = API_V1 + '/order/getShopCarList'
// 修改购物车数量
erp.editShopCar = API_V1 + '/order/editShopCar'
// 删除购物车
erp.delShopCar = API_V1 + '/order/delShopCar'
// 预下单
erp.saveShopCarPerOrder = API_V1 + '/order/saveShopCarPerOrder'
//获取订单确认信息
erp.getOrderConfirmInfo = API_V1 + '/order/getOrderConfirmInfo'
//购物车预下单中添加商品
erp.saveShopCarOnPerOrder = API_V1 + '/order/saveShopCarOnPerOrder'
//确认下单
erp.saveOrder = API_V1 + '/order/saveOrder'
//获取订单列表
erp.getOrderList = API_V1 + '/order/getOrderList'
//未支付前修改商品数量
erp.updateOrderNumBeforePay = API_V1 + '/order/updateOrderNumBeforePay'
//未支付前订单删除商品
erp.delOrderBeforePay = API_V1 + '/order/delOrderBeforePay'
//未支付前订单添加商品
erp.saveOrderBeforePay = API_V1 + '/order/saveOrderBeforePay'
//获取订单详情
erp.getOrderDetail = API_V1 + '/order/getOrderDetail'
//保存备注
erp.editOrderComment = API_V1 + '/order/editOrderComment'
// 商家修改订单
erp.storeEditOrder = API_V1 + '/order/storeEditOrder'
//用户or商家确认订单
erp.confirmOrder = API_V1 + '/order/confirmOrder'
//谈宝广场
erp.getDynamicyList = API_V1 + '/dynamic/getDynamicyList'
//获取关注店铺(展台)列表
erp.getAttentionStoreList = API_V1 + '/user/getAttentionStoreList'
//获取我的关注客户列表
erp.getAttentionCustomerList = API_V1 + '/user/getAttentionCustomerList'
// 获取顾客列表
erp.getCustomerList = API_V1 + '/user/getCustomerList'
// 添加备注/修改备注
erp.saveRemark = API_V1 + '/user/saveRemark'
//支付宝支付
erp.getOrderData = API_V1 + '/aliPay/getOrderData'
//获取APP支付数据
erp.getAppOrderData = API_V1 + '/aliPay/getAppOrderData'
//微信支付
erp.createOrder = API_V1 + '/wx/createOrder'
//游戏平台基本信息api
erp.getGamePlaformInfoList = API_V1 + '/gameplatform/getGamePlaformInfoList'
//直播平台基本信息api
erp.getLivePlatformInfoList = API_V1 + '/liveplatform/getLivePlatformInfoList'
//谈宝点赞
erp.renewReord = API_V1 + '/dynamic/renewReord'
//删除谈宝动态
erp.delDynamic = API_V1 + '/dynamic/delDynamic'
//发布动态
erp.addDynamic = API_V1 + '/dynamic/addDynamic'
//谈宝动态详情
erp.getDynamicDetailed = API_V1 + '/dynamic/getDynamicDetailed'
//用户评论动态和回复评论
erp.addComment = API_V1 + '/dynamic/addComment'
//送货员列表
erp.getDeliverymanInfoList = API_V1 + '/order/getDeliverymanInfoList'
//选择送货员
erp.chooseDeliveryman = API_V1 + '/order/chooseDeliveryman'
// 商家确认收款
erp.storeConfirm = API_V1 + '/order/storeConfirm'
// 商家发货
erp.storeShip = API_V1 + '/order/storeShip'

erp.storeShipPartial = API_V1 + '/order/storeShip/partial'
//用户收货
erp.customerReceipt = API_V1 + '/order/customerReceipt'

erp.customerReceivePartial = API_V1 + '/order/customer/receive/partial'

//订单评价
erp.saveProductComment = API_V1 + '/order/saveProductComment'
//线下支付
erp.payOffline = API_V1 + '/order/payOffline'
//用户评论动态和回复评论
erp.addComment = API_V1 + '/dynamic/addComment'
//获取我的模板
erp.getTemplateList = API_V1 + '/product/getTemplateList'
// 确定商品是否属于某用户
erp.checkProduct = API_V1 + '/product/checkProduct'

erp.getStoreExternalLinkList = API_V1 + '/store-external-link/list'

erp.getStoreExternalLink = API_V1 + '/store-external-link/storeId/linkId'


export default erp;



// WEBPACK FOOTER //
// ./src/utils/api.js